import request from '@/api/request'

/**
 * 导入学员
 */
export const importStudents = (data) => {
    return request({
        url: '/radioweb/adm/classStudent/importStudent',
        method: 'post',
        upload: true,
        data
    })
}
/**
 * 查询学员
 */
export const getStudentsList = (params) => {
    return request({
        url: '/radioweb/adm/classStudent/getListPage',
        method: 'get',
        params
    })
}
/**
 * 编辑学员
 */
export const updateStudent = (data) => {
    return request({
        url: '/radioweb/adm/classStudent/updateClassStudent',
        method: 'post',
        data
    })
}
/**
 * 删除学员
 */
export const delStudent = (data) => {
    return request({
        url: '/radioweb/adm/classStudent/delClassStudent',
        method: 'post',
        data
    })
}
/**
 * 修改学员状态
 */
export const stateStudent = (data) => {
    return request({
        url: '/radioweb/adm/classStudent/updateStatus',
        method: 'post',
        data
    })
}
/**
 * 异常列表
 */
export const getErrorList = (params) => {
    return request({
        url: '/radioweb/adm/importException/getListPage',
        method: 'get',
        params
    })
}